import { OnInit, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { tap, debounce, takeUntil, filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
var SiteHeaderComponent = /** @class */ (function () {
    function SiteHeaderComponent(changeDetector, router) {
        this.changeDetector = changeDetector;
        this.router = router;
        this.exploreFocused = false;
        this.exploreHoverSubject = new Subject();
        this.ngUnsubscribe = new Subject();
        this._exploreShown = false;
    }
    Object.defineProperty(SiteHeaderComponent.prototype, "exploreShown", {
        get: function () {
            return this._exploreShown;
        },
        set: function (value) {
            this._exploreShown = value;
            this.changeDetector.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    SiteHeaderComponent.prototype.ngOnInit = function () {
        this.initExploreMenu();
    };
    SiteHeaderComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.changeDetector.detach();
    };
    SiteHeaderComponent.prototype.handleMenuEnter = function () {
        this.exploreHoverSubject.next(true);
    };
    SiteHeaderComponent.prototype.handleMenuLeave = function () {
        this.exploreHoverSubject.next(false);
    };
    SiteHeaderComponent.prototype.initExploreMenu = function () {
        var _this = this;
        // hide menu on navigation
        this.router.events
            .pipe(filter(function (event) { return event instanceof NavigationEnd; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (event) {
            _this.exploreShown = false;
        });
        this.exploreHoverSubject.asObservable()
            .pipe(tap(function (hover) { return _this.exploreFocused = hover; }), 
        // throttle mouseleave
        debounce(function (hover) { return timer(hover ? 0 : 100); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (hover) {
            if (hover) {
                _this.exploreShown = true;
            }
            else if (!_this.exploreFocused) { // only trigger after delay
                _this.exploreShown = false;
            }
        });
    };
    return SiteHeaderComponent;
}());
export { SiteHeaderComponent };
